export type Language = 'de' | 'it' | 'en';

export const translations = {
  de: {
    nav: {
      infrastructure: 'IT Infrastruktur',
      ai: 'KI Lösungen',
      web: 'Web & App',
      blog: 'Blog',
      about: 'Über uns',
      login: 'Login',
      logout: 'Abmelden',
      dashboard: 'Dashboard',
      startProject: 'Projekt Starten',
      referenzen: 'Referenzen'
    },
    auth: {
      signInTitle: 'Willkommen zurück',
      signUpTitle: 'Account erstellen',
      email: 'E-Mail Adresse',
      password: 'Passwort',
      username: 'Benutzername',
      signInAction: 'Einloggen',
      signUpAction: 'Registrieren',
      noAccount: 'Noch keinen Account?',
      hasAccount: 'Bereits registriert?',
      loggingIn: 'Melde an...',
      signingUp: 'Registriere...',
      errorGeneric: 'Ein Fehler ist aufgetreten.',
      errorInvalidLogin: 'Ungültige Anmeldedaten.',
      errorUserTaken: 'Benutzer bereits registriert.',
      successRegister: 'Registrierung erfolgreich! Bitte E-Mail bestätigen.'
    },
    hero: {
      tag: 'ENTERPRISE v2.0',
      title: 'Hardware\nPräzision trifft\n',
      titleHighlight: 'Lokale KI.',
      subtitle: 'Haben Sie sensiblen Datenverkehr? Unsere Plattform bietet alles von Custom-Servern bis zu privaten LLMs. Maximale Sicherheit aus Acri, Italien.',
      cta: 'Projekt Starten',
      solutions: 'Lösungen',
      badge_security: 'Sicherheit',
      badge_gdpr: 'DSGVO Ready',
      badge_hosted: 'Hosted in',
      badge_location: 'EU / Italien'
    },
    bento: {
      stackTitle: 'Technologie Stack',
      stackDesc: 'Maßgeschneiderte Lösungen für komplexe Anforderungen. Von der Hardware bis zur Applikation.',
      aiTitle: 'European AI Sovereignty',
      aiDesc: 'Wir verarbeiten personenbezogene Daten ausschließlich in der EU. Ob via Mistral AI oder lokal: 0% Transfer in die USA.',
      serverTitle: 'Custom Server',
      serverDesc: 'High-Performance Racks, GPU Cluster und Storage Lösungen designed in Acri.',
      cloudTitle: 'Secure Cloud',
      cloudDesc: 'DSGVO-konforme Nextcloud & Kubernetes Cluster.',
      webTitle: 'Web & App Architecture',
      webDesc: 'Scalable React Frontends, Node.js Backends und Enterprise Apps.'
    },
    footer: {
      tagline: 'Lokale Sicherheit, Globale Technik.',
      tagline2: 'Wir verbinden italienische Hardware-Expertise mit modernster KI-Architektur.',
      status: 'Alle Systeme betriebsbereit',
      services: 'Services',
      legalTitle: 'Rechtliches',
      legalImprint: 'Impressum',
      legalPrivacy: 'Datenschutz (DSGVO)',
      legalTerms: 'AGB',
      copyright: 'HenselX Enterprise IT. Alle Rechte vorbehalten.',
      acriHosted: 'Proudly hosted in Acri',
      acriSub: 'Kalabrien, Italien — im Herzen der EU.',
      hqTitle: 'HenselX · Acri HQ'
    },
    feature: {
      title1: 'Local AI.',
      title2: 'Global Speed.',
      highlight: '100% Deine Hardware.',
      subtitle: 'Keine Wartezeiten. Keine API-Limits.',
      subtitle2: 'Deploye lokale LLMs so einfach wie eine Rechnung zu schreiben.',
      cta: 'Start Architecture Setup'
    },
    sovereign: {
      badge: 'SVC-STACK',
      title: 'The Sovereign Stack.',
      subtitle: 'Drei Ebenen. Eine Garantie:',
      subtitleLine2: 'Kein Bit Ihrer Daten verlässt das EU-Territorium.',
      mobileOpen: 'Details einblenden',
      mobileClose: 'Weniger'
    },
    impact: {
      badge: 'PROOF OF WORK',
      title: 'Zahlen, die',
      titleHighlight: 'für sich sprechen.',
      hosted: 'Proudly hosted in Acri',
      hostedSub: 'Kalabrien, Italien — im Herzen der EU.'
    },
    testimonials: {
      badge: 'KUNDENSTIMMEN',
      title: 'Was Kunden',
      titleHighlight: 'wirklich sagen.'
    },
    about: {
      heroTitle1: 'Über',
      heroTitle2: 'HenselX.',
      heroSub: 'Von der ersten Platine bis zum neuronalen Netzwerk. Eine Geschichte von Innovation aus Acri, Kalabrien.',
      founderBadge: 'GRÜNDER',
      founderQuote: '"Technik muss dem Menschen dienen, nicht umgekehrt."',
      bio1: 'Vor über 38 Jahren begann alles mit der Faszination für Hardware. Heute kombiniert HenselX diese tiefe technische Expertise mit modernster Software-Entwicklung und Privacy-First-KI — alles aus Acri, Kalabrien, mitten in der EU.',
      bio2: 'In einer Welt, in der US-Cloud-Konzerne Datensouveränität aushöhlen, steht HenselX für das Gegenteil: Bare-Metal-Server, die dem Kunden gehören. KI-Modelle, die das Unternehmen nie verlassen. Code, der als Handwerk gilt — nicht als Commodity.',
      stat1Label: 'Jahre Erfahrung',
      stat2Label: 'EU-Datensouveränität',
      stat3Label: 'US-Cloud-Exposure',
      stat4Label: 'SLA Uptime',
      historyBadge: 'STATIONEN',
      historyTitle: 'Die Chronik.',
      historySub: '1991 → heute · Stationen können sich zeitlich überschneiden.'
    },
    timeline: {
      era1: 'Gründungsphase',
      era2: 'Internationale Expansion',
      era3: 'HenselX Ära',
      currentLabel: 'Aktuell',
      yearsLabel: 'Jahre',
      parallelNote: 'Parallel zu anderen Stationen',
      footer: '34 Jahre · 4 Länder · 1 Vision',
      mobileOpen: 'Details einblenden',
      mobileClose: 'Weniger'
    },
    service: {
      backLink: 'Alle Services',
      problemLabel: 'Das Problem',
      solutionLabel: 'Die HenselX Lösung',
      featuresLabel: 'Was Sie bekommen',
      featuresTitle: 'Liefert HenselX.',
      processLabel: 'Prozess',
      ctaTitle: 'Ihr Projekt startet hier.',
      ctaBody: 'Kostenloses Erstgespräch — wir analysieren Ihren Status und skizzieren den schnellsten Weg zum Ziel.',
      ctaButton: 'Jetzt Anfragen',
      notFound: 'Service nicht gefunden.',
      notFoundLink: '← Zurück zur Startseite'
    },
    showcase: {
      badge: 'REFERENZEN',
      heading1: 'Was wir',
      heading2: 'gebaut haben.',
      projectLabel: 'Projekt',
      infraLabel: 'Infrastruktur'
    },
    referenzen: {
      breadcrumb: 'HenselX / Referenzen',
      title1: 'Unsere',
      title2: 'Projekte.',
      description: 'Jedes Projekt gebaut mit einer Obsession: maximale Performance, vollständige EU-Datensouveränität, kein US-Cloud-Exposure.'
    }
  },
  it: {
    nav: {
      infrastructure: 'Infrastruttura IT',
      ai: 'Soluzioni AI',
      web: 'Web & App',
      blog: 'Blog',
      about: 'Chi Siamo',
      login: 'Accedi',
      logout: 'Esci',
      dashboard: 'Dashboard',
      startProject: 'Inizia Progetto',
      referenzen: 'Referenze'
    },
    auth: {
      signInTitle: 'Bentornato',
      signUpTitle: 'Crea Account',
      email: 'Indirizzo Email',
      password: 'Password',
      username: 'Nome Utente',
      signInAction: 'Accedi',
      signUpAction: 'Registrati',
      noAccount: 'Non hai un account?',
      hasAccount: 'Hai già un account?',
      loggingIn: 'Accesso in corso...',
      signingUp: 'Registrazione...',
      errorGeneric: 'Si è verificato un errore.',
      errorInvalidLogin: 'Credenziali non valide.',
      errorUserTaken: 'Utente già registrato.',
      successRegister: 'Registrazione riuscita! Controlla la tua email.'
    },
    hero: {
      tag: 'IMPRESA v2.0',
      title: 'Precisione\nHardware incontra\n',
      titleHighlight: 'AI Locale.',
      subtitle: 'Gestite dati sensibili? La nostra piattaforma offre tutto, dai server personalizzati agli LLM privati. Massima sicurezza da Acri, Italia.',
      cta: 'Inizia Progetto',
      solutions: 'Soluzioni',
      badge_security: 'Sicurezza',
      badge_gdpr: 'Pronto GDPR',
      badge_hosted: 'Ospitato in',
      badge_location: 'UE / Italia'
    },
    bento: {
      stackTitle: 'Stack Tecnologico',
      stackDesc: 'Soluzioni su misura per esigenze complesse. Dall\'hardware all\'applicazione.',
      aiTitle: 'Sovranità AI Europea',
      aiDesc: 'Trattiamo i dati personali esclusivamente nell\'UE. Sia via Mistral AI che locale: 0% trasferimento in USA.',
      serverTitle: 'Server Personalizzati',
      serverDesc: 'Rack ad alte prestazioni, cluster GPU e soluzioni di storage progettate ad Acri.',
      cloudTitle: 'Cloud Sicuro',
      cloudDesc: 'Cluster Nextcloud e Kubernetes conformi al GDPR.',
      webTitle: 'Architettura Web & App',
      webDesc: 'Frontend React scalabili, Backend Node.js e App Enterprise.'
    },
    footer: {
      tagline: 'Sicurezza Locale, Tecnologia Globale.',
      tagline2: 'Uniamo l\'expertise hardware italiana con la moderna architettura AI.',
      status: 'Tutti i sistemi operativi',
      services: 'Servizi',
      legalTitle: 'Legale',
      legalImprint: 'Informazioni Legali',
      legalPrivacy: 'Privacy (GDPR)',
      legalTerms: 'Termini',
      copyright: 'HenselX Enterprise IT. Tutti i diritti riservati.',
      acriHosted: 'Con orgoglio ospitato ad Acri',
      acriSub: 'Calabria, Italia — nel cuore dell\'UE.',
      hqTitle: 'HenselX · Sede Acri'
    },
    feature: {
      title1: 'Local AI.',
      title2: 'Velocità Globale.',
      highlight: '100% il tuo hardware.',
      subtitle: 'Nessuna attesa. Nessun limite API.',
      subtitle2: 'Installa LLM locali facilmente come inviare una fattura.',
      cta: 'Start Architecture Setup'
    },
    sovereign: {
      badge: 'SVC-STACK',
      title: 'The Sovereign Stack.',
      subtitle: 'Tre livelli. Una garanzia:',
      subtitleLine2: 'Nessun bit dei vostri dati lascia il territorio UE.',
      mobileOpen: 'Mostra dettagli',
      mobileClose: 'Meno'
    },
    impact: {
      badge: 'PROOF OF WORK',
      title: 'Numeri che',
      titleHighlight: 'parlano da soli.',
      hosted: 'Con orgoglio ospitato ad Acri',
      hostedSub: 'Calabria, Italia — nel cuore dell\'UE.'
    },
    testimonials: {
      badge: 'TESTIMONIANZE',
      title: 'Cosa dicono',
      titleHighlight: 'davvero i clienti.'
    },
    about: {
      heroTitle1: 'Chi siamo',
      heroTitle2: 'HenselX.',
      heroSub: 'Dal primo circuito stampato alle reti neurali. Una storia di innovazione da Acri, Calabria.',
      founderBadge: 'FONDATORE',
      founderQuote: '"La tecnologia deve servire l\'uomo, non il contrario."',
      bio1: 'Più di 38 anni fa tutto è iniziato con la passione per l\'hardware. Oggi HenselX combina questa profonda expertise tecnica con lo sviluppo software più avanzato e AI privacy-first — tutto da Acri, Calabria, nel cuore dell\'UE.',
      bio2: 'In un mondo in cui i giganti del cloud statunitense erodono la sovranità dei dati, HenselX rappresenta il contrario: server Bare-Metal di proprietà del cliente. Modelli AI che non lasciano mai l\'azienda. Codice trattato come artigianato — non come commodity.',
      stat1Label: 'Anni di esperienza',
      stat2Label: 'Sovranità Dati UE',
      stat3Label: 'US-Cloud-Exposure',
      stat4Label: 'SLA Uptime',
      historyBadge: 'STAZIONI',
      historyTitle: 'La Cronaca.',
      historySub: '1991 → oggi · Le tappe possono sovrapporsi nel tempo.'
    },
    timeline: {
      era1: 'Fase Fondativa',
      era2: 'Espansione Internazionale',
      era3: 'Era HenselX',
      currentLabel: 'Attuale',
      yearsLabel: 'Anni',
      parallelNote: 'In parallelo ad altre tappe',
      footer: '34 Anni · 4 Paesi · 1 Visione',
      mobileOpen: 'Mostra dettagli',
      mobileClose: 'Meno'
    },
    service: {
      backLink: 'Tutti i Servizi',
      problemLabel: 'Il Problema',
      solutionLabel: 'La Soluzione HenselX',
      featuresLabel: 'Cosa ricevete',
      featuresTitle: 'Fornisce HenselX.',
      processLabel: 'Processo',
      ctaTitle: 'Il vostro progetto inizia qui.',
      ctaBody: "Consulenza gratuita — analizziamo la vostra situazione e tracciamo il percorso più rapido verso l'obiettivo.",
      ctaButton: 'Richiedi ora',
      notFound: 'Servizio non trovato.',
      notFoundLink: '← Torna alla home'
    },
    showcase: {
      badge: 'REFERENZE',
      heading1: 'Cosa abbiamo',
      heading2: 'realizzato.',
      projectLabel: 'Progetto',
      infraLabel: 'Infrastruttura'
    },
    referenzen: {
      breadcrumb: 'HenselX / Referenze',
      title1: 'I nostri',
      title2: 'Progetti.',
      description: "Ogni progetto realizzato con un'ossessione: performance massima, sovranità dei dati UE completa, zero esposizione al cloud statunitense."
    }
  },
  en: {
    nav: {
      infrastructure: 'IT Infrastructure',
      ai: 'AI Solutions',
      web: 'Web & App',
      blog: 'Blog',
      about: 'About Us',
      login: 'Login',
      logout: 'Logout',
      dashboard: 'Dashboard',
      startProject: 'Start Project',
      referenzen: 'References'
    },
    auth: {
      signInTitle: 'Welcome Back',
      signUpTitle: 'Create Account',
      email: 'Email Address',
      password: 'Password',
      username: 'Username',
      signInAction: 'Sign In',
      signUpAction: 'Sign Up',
      noAccount: 'No account yet?',
      hasAccount: 'Already registered?',
      loggingIn: 'Logging in...',
      signingUp: 'Signing up...',
      errorGeneric: 'An error occurred.',
      errorInvalidLogin: 'Invalid login credentials.',
      errorUserTaken: 'User already registered.',
      successRegister: 'Registration successful! Please verify your email.'
    },
    hero: {
      tag: 'ENTERPRISE v2.0',
      title: 'Hardware\nPrecision meets\n',
      titleHighlight: 'Local AI.',
      subtitle: 'Handling sensitive traffic? Our platform offers everything from custom servers to private LLMs. Maximum security from Acri, Italy.',
      cta: 'Start Project',
      solutions: 'Solutions',
      badge_security: 'Security',
      badge_gdpr: 'GDPR Ready',
      badge_hosted: 'Hosted in',
      badge_location: 'EU / Italy'
    },
    bento: {
      stackTitle: 'Technology Stack',
      stackDesc: 'Tailored solutions for complex requirements. From hardware to application.',
      aiTitle: 'European AI Sovereignty',
      aiDesc: 'We process personal data exclusively in the EU. Whether via Mistral AI or local: 0% transfer to the USA.',
      serverTitle: 'Custom Server',
      serverDesc: 'High-performance racks, GPU clusters, and storage solutions designed in Acri.',
      cloudTitle: 'Secure Cloud',
      cloudDesc: 'GDPR-compliant Nextcloud & Kubernetes clusters.',
      webTitle: 'Web & App Architecture',
      webDesc: 'Scalable React frontends, Node.js backends, and enterprise apps.'
    },
    footer: {
      tagline: 'Local Security, Global Technology.',
      tagline2: 'We combine Italian hardware expertise with cutting-edge AI architecture.',
      status: 'All Systems Operational',
      services: 'Services',
      legalTitle: 'Legal',
      legalImprint: 'Legal Notice',
      legalPrivacy: 'Privacy (GDPR)',
      legalTerms: 'Terms',
      copyright: 'HenselX Enterprise IT. All rights reserved.',
      acriHosted: 'Proudly hosted in Acri',
      acriSub: 'Calabria, Italy — in the heart of the EU.',
      hqTitle: 'HenselX · Acri HQ'
    },
    feature: {
      title1: 'Local AI.',
      title2: 'Global Speed.',
      highlight: '100% Your Hardware.',
      subtitle: 'No waiting times. No API limits.',
      subtitle2: 'Deploy local LLMs as easily as writing an invoice.',
      cta: 'Start Architecture Setup'
    },
    sovereign: {
      badge: 'SVC-STACK',
      title: 'The Sovereign Stack.',
      subtitle: 'Three levels. One guarantee:',
      subtitleLine2: 'Not a single bit of your data leaves EU territory.',
      mobileOpen: 'Show details',
      mobileClose: 'Less'
    },
    impact: {
      badge: 'PROOF OF WORK',
      title: 'Numbers that',
      titleHighlight: 'speak for themselves.',
      hosted: 'Proudly hosted in Acri',
      hostedSub: 'Calabria, Italy — in the heart of the EU.'
    },
    testimonials: {
      badge: 'TESTIMONIALS',
      title: 'What clients',
      titleHighlight: 'really say.'
    },
    about: {
      heroTitle1: 'About',
      heroTitle2: 'HenselX.',
      heroSub: 'From the first circuit board to the neural network. A story of innovation from Acri, Calabria.',
      founderBadge: 'FOUNDER',
      founderQuote: '"Technology must serve humanity, not the other way around."',
      bio1: 'Over 38 years ago it all began with a fascination for hardware. Today HenselX combines that deep technical expertise with cutting-edge software development and privacy-first AI — all from Acri, Calabria, in the heart of the EU.',
      bio2: 'In a world where US cloud giants are eroding data sovereignty, HenselX stands for the opposite: Bare-Metal servers owned by the client. AI models that never leave the company. Code treated as craftsmanship — not as a commodity.',
      stat1Label: 'Years of Experience',
      stat2Label: 'EU Data Sovereignty',
      stat3Label: 'US-Cloud-Exposure',
      stat4Label: 'SLA Uptime',
      historyBadge: 'STATIONS',
      historyTitle: 'The Chronicle.',
      historySub: '1991 → today · Stations may overlap in time.'
    },
    timeline: {
      era1: 'Founding Phase',
      era2: 'International Expansion',
      era3: 'HenselX Era',
      currentLabel: 'Current',
      yearsLabel: 'Years',
      parallelNote: 'Parallel to other stations',
      footer: '34 Years · 4 Countries · 1 Vision',
      mobileOpen: 'Show details',
      mobileClose: 'Less'
    },
    service: {
      backLink: 'All Services',
      problemLabel: 'The Problem',
      solutionLabel: 'The HenselX Solution',
      featuresLabel: 'What you get',
      featuresTitle: 'Delivered by HenselX.',
      processLabel: 'Process',
      ctaTitle: 'Your project starts here.',
      ctaBody: 'Free initial consultation — we analyse your current setup and outline the fastest path to your goal.',
      ctaButton: 'Get in touch',
      notFound: 'Service not found.',
      notFoundLink: '← Back to Home'
    },
    showcase: {
      badge: 'REFERENCES',
      heading1: 'What we',
      heading2: 'have built.',
      projectLabel: 'Project',
      infraLabel: 'Infrastructure'
    },
    referenzen: {
      breadcrumb: 'HenselX / References',
      title1: 'Our',
      title2: 'Projects.',
      description: 'Every project built with one obsession: maximum performance, full EU data sovereignty, zero US cloud exposure.'
    }
  }
};
